
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/**
 * Returns detailed type as string (instead of just 'object' for arrays etc)
 * @private
 * @param {any} value js value
 * @returns {String} type of value
 * @example
 * typeOf({}); // 'object'
 * typeOf([]); // 'array'
 * typeOf(function() {}); // 'function'
 * typeOf(/a/); // 'regexp'
 * typeOf(new Date()); // 'date'
 * typeOf(null); // 'null'
 * typeOf(undefined); // 'undefined'
 * typeOf('a'); // 'string'
 * typeOf(1); // 'number'
 * typeOf(true); // 'boolean'
 * typeOf(new Map()); // 'map'
 * typeOf(new Set()); // 'map'
 */ function $ce9158473db88422$var$typeOf(value) {
    if (value === null) return 'null';
    if (value !== Object(value)) return typeof value;
    return ({}).toString.call(value).slice(8, -1).toLowerCase();
}
/**
 * Checks if input string is empty
 * @param  {String} input text input
 * @return {Boolean} true if no input
 */ function $ce9158473db88422$var$isEmpty(input) {
    if ($ce9158473db88422$var$typeOf(input) !== 'string') return true;
    return !input.length;
}
/**
 * Takes a character and a unicode range. Returns true if the char is in the range.
 * @param  {String}  char  unicode character
 * @param  {Number}  start unicode start range
 * @param  {Number}  end   unicode end range
 * @return {Boolean}
 */ function $ce9158473db88422$var$isCharInRange(char = '', start, end) {
    if ($ce9158473db88422$var$isEmpty(char)) return false;
    const code = char.charCodeAt(0);
    return start <= code && code <= end;
}
const $ce9158473db88422$export$a4ad2735b021c132 = '5.3.1';
const $ce9158473db88422$export$4cb93ec9ed11137c = {
    HIRAGANA: 'toHiragana',
    KATAKANA: 'toKatakana'
};
const $ce9158473db88422$export$9b45cb7ce8e39e14 = {
    HEPBURN: 'hepburn'
};
/**
 * Default config for WanaKana, user passed options will be merged with these
 * @type {DefaultOptions}
 * @name DefaultOptions
 * @property {Boolean} [useObsoleteKana=false] - Set to true to use obsolete characters, such as ゐ and ゑ.
 * @example
 * toHiragana('we', { useObsoleteKana: true })
 * // => 'ゑ'
 * @property {Boolean} [passRomaji=false] - Set to true to pass romaji when using mixed syllabaries with toKatakana() or toHiragana()
 * @example
 * toHiragana('only convert the katakana: ヒラガナ', { passRomaji: true })
 * // => "only convert the katakana: ひらがな"
 * @property {Boolean} [convertLongVowelMark=true] - Set to false to prevent conversions of 'ー' to extended vowels with toHiragana()
 * @example
 * toHiragana('ラーメン', { convertLongVowelMark: false });
 * // => 'らーめん
 * @property {Boolean} [upcaseKatakana=false] - Set to true to convert katakana to uppercase using toRomaji()
 * @example
 * toRomaji('ひらがな カタカナ', { upcaseKatakana: true })
 * // => "hiragana KATAKANA"
 * @property {Boolean | 'toHiragana' | 'toKatakana'} [IMEMode=false] - Set to true, 'toHiragana', or 'toKatakana' to handle conversion while it is being typed.
 * @property {'hepburn'} [romanization='hepburn'] - choose toRomaji() romanization map (currently only 'hepburn')
 * @property {Object.<String, String>} [customKanaMapping] - custom map will be merged with default conversion
 * @example
 * toKana('wanakana', { customKanaMapping: { na: 'に', ka: 'Bana' }) };
 * // => 'わにBanaに'
 * @property {Object.<String, String>} [customRomajiMapping] - custom map will be merged with default conversion
 * @example
 * toRomaji('つじぎり', { customRomajiMapping: { じ: 'zi', つ: 'tu', り: 'li' }) };
 * // => 'tuzigili'
 */ const $ce9158473db88422$var$DEFAULT_OPTIONS = {
    useObsoleteKana: false,
    passRomaji: false,
    convertLongVowelMark: true,
    upcaseKatakana: false,
    IMEMode: false,
    romanization: $ce9158473db88422$export$9b45cb7ce8e39e14.HEPBURN
};
const $ce9158473db88422$var$LATIN_UPPERCASE_START = 0x41;
const $ce9158473db88422$var$LATIN_UPPERCASE_END = 0x5a;
const $ce9158473db88422$var$LOWERCASE_ZENKAKU_START = 0xff41;
const $ce9158473db88422$var$LOWERCASE_ZENKAKU_END = 0xff5a;
const $ce9158473db88422$var$UPPERCASE_ZENKAKU_START = 0xff21;
const $ce9158473db88422$var$UPPERCASE_ZENKAKU_END = 0xff3a;
const $ce9158473db88422$var$HIRAGANA_START = 0x3041;
const $ce9158473db88422$var$HIRAGANA_END = 0x3096;
const $ce9158473db88422$var$KATAKANA_START = 0x30a1;
const $ce9158473db88422$var$KATAKANA_END = 0x30fc;
const $ce9158473db88422$var$KANJI_START = 0x4e00;
const $ce9158473db88422$var$KANJI_END = 0x9faf;
const $ce9158473db88422$var$KANJI_ITERATION_MARK = 0x3005; // 々
const $ce9158473db88422$var$PROLONGED_SOUND_MARK = 0x30fc; // ー
const $ce9158473db88422$var$KANA_SLASH_DOT = 0x30fb; // ・
const $ce9158473db88422$var$ZENKAKU_NUMBERS = [
    0xff10,
    0xff19
];
const $ce9158473db88422$var$ZENKAKU_UPPERCASE = [
    $ce9158473db88422$var$UPPERCASE_ZENKAKU_START,
    $ce9158473db88422$var$UPPERCASE_ZENKAKU_END
];
const $ce9158473db88422$var$ZENKAKU_LOWERCASE = [
    $ce9158473db88422$var$LOWERCASE_ZENKAKU_START,
    $ce9158473db88422$var$LOWERCASE_ZENKAKU_END
];
const $ce9158473db88422$var$ZENKAKU_PUNCTUATION_1 = [
    0xff01,
    0xff0f
];
const $ce9158473db88422$var$ZENKAKU_PUNCTUATION_2 = [
    0xff1a,
    0xff1f
];
const $ce9158473db88422$var$ZENKAKU_PUNCTUATION_3 = [
    0xff3b,
    0xff3f
];
const $ce9158473db88422$var$ZENKAKU_PUNCTUATION_4 = [
    0xff5b,
    0xff60
];
const $ce9158473db88422$var$ZENKAKU_SYMBOLS_CURRENCY = [
    0xffe0,
    0xffee
];
const $ce9158473db88422$var$HIRAGANA_CHARS = [
    0x3040,
    0x309f
];
const $ce9158473db88422$var$KATAKANA_CHARS = [
    0x30a0,
    0x30ff
];
const $ce9158473db88422$var$HANKAKU_KATAKANA = [
    0xff66,
    0xff9f
];
const $ce9158473db88422$var$KATAKANA_PUNCTUATION = [
    0x30fb,
    0x30fc
];
const $ce9158473db88422$var$KANA_PUNCTUATION = [
    0xff61,
    0xff65
];
const $ce9158473db88422$var$CJK_SYMBOLS_PUNCTUATION = [
    0x3000,
    0x303f
];
const $ce9158473db88422$var$COMMON_CJK = [
    0x4e00,
    0x9fff
];
const $ce9158473db88422$var$RARE_CJK = [
    0x3400,
    0x4dbf
];
const $ce9158473db88422$var$KANA_RANGES = [
    $ce9158473db88422$var$HIRAGANA_CHARS,
    $ce9158473db88422$var$KATAKANA_CHARS,
    $ce9158473db88422$var$KANA_PUNCTUATION,
    $ce9158473db88422$var$HANKAKU_KATAKANA
];
const $ce9158473db88422$var$JA_PUNCTUATION_RANGES = [
    $ce9158473db88422$var$CJK_SYMBOLS_PUNCTUATION,
    $ce9158473db88422$var$KANA_PUNCTUATION,
    $ce9158473db88422$var$KATAKANA_PUNCTUATION,
    $ce9158473db88422$var$ZENKAKU_PUNCTUATION_1,
    $ce9158473db88422$var$ZENKAKU_PUNCTUATION_2,
    $ce9158473db88422$var$ZENKAKU_PUNCTUATION_3,
    $ce9158473db88422$var$ZENKAKU_PUNCTUATION_4,
    $ce9158473db88422$var$ZENKAKU_SYMBOLS_CURRENCY
];
// All Japanese unicode start and end ranges
// Includes kanji, kana, zenkaku latin chars, punctuation, and number ranges.
const $ce9158473db88422$var$JAPANESE_RANGES = [
    ...$ce9158473db88422$var$KANA_RANGES,
    ...$ce9158473db88422$var$JA_PUNCTUATION_RANGES,
    $ce9158473db88422$var$ZENKAKU_UPPERCASE,
    $ce9158473db88422$var$ZENKAKU_LOWERCASE,
    $ce9158473db88422$var$ZENKAKU_NUMBERS,
    $ce9158473db88422$var$COMMON_CJK,
    $ce9158473db88422$var$RARE_CJK
];
const $ce9158473db88422$var$MODERN_ENGLISH = [
    0x0000,
    0x007f
];
const $ce9158473db88422$var$HEPBURN_MACRON_RANGES = [
    [
        0x0100,
        0x0101
    ],
    [
        0x0112,
        0x0113
    ],
    [
        0x012a,
        0x012b
    ],
    [
        0x014c,
        0x014d
    ],
    [
        0x016a,
        0x016b
    ]
];
const $ce9158473db88422$var$SMART_QUOTE_RANGES = [
    [
        0x2018,
        0x2019
    ],
    [
        0x201c,
        0x201d
    ]
];
const $ce9158473db88422$var$ROMAJI_RANGES = [
    $ce9158473db88422$var$MODERN_ENGLISH,
    ...$ce9158473db88422$var$HEPBURN_MACRON_RANGES
];
const $ce9158473db88422$var$EN_PUNCTUATION_RANGES = [
    [
        0x20,
        0x2f
    ],
    [
        0x3a,
        0x3f
    ],
    [
        0x5b,
        0x60
    ],
    [
        0x7b,
        0x7e
    ],
    ...$ce9158473db88422$var$SMART_QUOTE_RANGES
];
/**
 * Tests a character. Returns true if the character is [Katakana](https://en.wikipedia.org/wiki/Katakana).
 * @param  {String} char character string to test
 * @return {Boolean}
 */ function $ce9158473db88422$var$isCharJapanese(char = '') {
    return $ce9158473db88422$var$JAPANESE_RANGES.some(([start, end])=>$ce9158473db88422$var$isCharInRange(char, start, end));
}
/**
 * Test if `input` only includes [Kanji](https://en.wikipedia.org/wiki/Kanji), [Kana](https://en.wikipedia.org/wiki/Kana), zenkaku numbers, and JA punctuation/symbols.”
 * @param  {String} [input=''] text
 * @param  {RegExp} [allowed] additional test allowed to pass for each char
 * @return {Boolean} true if passes checks
 * @example
 * isJapanese('泣き虫')
 * // => true
 * isJapanese('あア')
 * // => true
 * isJapanese('２月') // Zenkaku numbers allowed
 * // => true
 * isJapanese('泣き虫。！〜＄') // Zenkaku/JA punctuation
 * // => true
 * isJapanese('泣き虫.!~$') // Latin punctuation fails
 * // => false
 * isJapanese('A泣き虫')
 * // => false
 * isJapanese('≪偽括弧≫', /[≪≫]/);
 * // => true
 */ function $ce9158473db88422$export$33dfa193fc452c06(input = '', allowed) {
    const augmented = $ce9158473db88422$var$typeOf(allowed) === 'regexp';
    return $ce9158473db88422$var$isEmpty(input) ? false : [
        ...input
    ].every((char)=>{
        const isJa = $ce9158473db88422$var$isCharJapanese(char);
        return !augmented ? isJa : isJa || allowed.test(char);
    });
}
var $ce9158473db88422$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $ce9158473db88422$var$isEqual(first, second) {
    if (first === second) return true;
    if ($ce9158473db88422$var$safeIsNaN(first) && $ce9158473db88422$var$safeIsNaN(second)) return true;
    return false;
}
function $ce9158473db88422$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$ce9158473db88422$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $ce9158473db88422$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $ce9158473db88422$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}
var $ce9158473db88422$var$has = Object.prototype.hasOwnProperty;
function $ce9158473db88422$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($ce9158473db88422$var$dequal(key, tar)) return key;
    }
}
function $ce9158473db88422$var$dequal(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $ce9158473db88422$var$dequal(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $ce9158473db88422$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $ce9158473db88422$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$ce9158473db88422$var$dequal(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($ce9158473db88422$var$has.call(foo, ctor) && ++len && !$ce9158473db88422$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$ce9158473db88422$var$dequal(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
/**
 * Easy re-use of merging with default options
 * @param {Object} opts user options
 * @returns user options merged over default options
 */ const $ce9158473db88422$var$mergeWithDefaultOptions = (opts = {})=>Object.assign({}, $ce9158473db88422$var$DEFAULT_OPTIONS, opts);
function $ce9158473db88422$var$applyMapping(string, mapping, convertEnding) {
    const root = mapping;
    function nextSubtree(tree, nextChar) {
        const subtree = tree[nextChar];
        if (subtree === undefined) return undefined;
        // if the next child node does not have a node value, set its node value to the input
        return Object.assign({
            '': tree[''] + nextChar
        }, tree[nextChar]);
    }
    function newChunk(remaining, currentCursor) {
        // start parsing a new chunk
        const firstChar = remaining.charAt(0);
        return parse(Object.assign({
            '': firstChar
        }, root[firstChar]), remaining.slice(1), currentCursor, currentCursor + 1);
    }
    function parse(tree, remaining, lastCursor, currentCursor) {
        if (!remaining) {
            if (convertEnding || Object.keys(tree).length === 1) // nothing more to consume, just commit the last chunk and return it
            // so as to not have an empty element at the end of the result
            return tree[''] ? [
                [
                    lastCursor,
                    currentCursor,
                    tree['']
                ]
            ] : [];
            // if we don't want to convert the ending, because there are still possible continuations
            // return null as the final node value
            return [
                [
                    lastCursor,
                    currentCursor,
                    null
                ]
            ];
        }
        if (Object.keys(tree).length === 1) return [
            [
                lastCursor,
                currentCursor,
                tree['']
            ]
        ].concat(newChunk(remaining, currentCursor));
        const subtree = nextSubtree(tree, remaining.charAt(0));
        if (subtree === undefined) return [
            [
                lastCursor,
                currentCursor,
                tree['']
            ]
        ].concat(newChunk(remaining, currentCursor));
        // continue current branch
        return parse(subtree, remaining.slice(1), lastCursor, currentCursor + 1);
    }
    return newChunk(string, 0);
}
// transform the tree, so that for example hepburnTree['ゔ']['ぁ'][''] === 'va'
// or kanaTree['k']['y']['a'][''] === 'きゃ'
function $ce9158473db88422$var$transform(tree) {
    return Object.entries(tree).reduce((map, [char, subtree])=>{
        const endOfBranch = $ce9158473db88422$var$typeOf(subtree) === 'string';
        // eslint-disable-next-line no-param-reassign
        map[char] = endOfBranch ? {
            '': subtree
        } : $ce9158473db88422$var$transform(subtree);
        return map;
    }, {});
}
function $ce9158473db88422$var$getSubTreeOf(tree, string) {
    return string.split('').reduce((correctSubTree, char)=>{
        if (correctSubTree[char] === undefined) // eslint-disable-next-line no-param-reassign
        correctSubTree[char] = {};
        return correctSubTree[char];
    }, tree);
}
/**
 * Creates a custom mapping tree, returns a function that accepts a defaultMap which the newly created customMapping will be merged with and returned
 * (customMap) => (defaultMap) => mergedMap
 * @param  {Object} customMap { 'ka' : 'な' }
 * @return {Function} (defaultMap) => defaultMergedWithCustomMap
 * @example
 * const sillyMap = createCustomMapping({ 'ちゃ': 'time', '茎': 'cookie'　});
 * // sillyMap is passed defaultMapping to merge with when called in toRomaji()
 * toRomaji("It's 茎 ちゃ よ", { customRomajiMapping: sillyMap });
 * // => 'It's cookie time yo';
 */ function $ce9158473db88422$var$createCustomMapping(customMap = {}) {
    const customTree = {};
    if ($ce9158473db88422$var$typeOf(customMap) === 'object') Object.entries(customMap).forEach(([roma, kana])=>{
        let subTree = customTree;
        roma.split('').forEach((char)=>{
            if (subTree[char] === undefined) subTree[char] = {};
            subTree = subTree[char];
        });
        subTree[''] = kana;
    });
    return function makeMap(map) {
        const mapCopy = JSON.parse(JSON.stringify(map));
        function transformMap(mapSubtree, customSubtree) {
            if (mapSubtree === undefined || $ce9158473db88422$var$typeOf(mapSubtree) === 'string') return customSubtree;
            return Object.entries(customSubtree).reduce((newSubtree, [char, subtree])=>{
                // eslint-disable-next-line no-param-reassign
                newSubtree[char] = transformMap(mapSubtree[char], subtree);
                return newSubtree;
            }, mapSubtree);
        }
        return transformMap(mapCopy, customTree);
    };
}
// allow consumer to pass either function or object as customMapping
function $ce9158473db88422$var$mergeCustomMapping(map, customMapping) {
    if (!customMapping) return map;
    return $ce9158473db88422$var$typeOf(customMapping) === 'function' ? customMapping(map) : $ce9158473db88422$var$createCustomMapping(customMapping)(map);
}
// NOTE: not exactly kunrei shiki, for example ぢゃ -> dya instead of zya, to avoid name clashing
/* eslint-disable */ // prettier-ignore
const $ce9158473db88422$var$BASIC_KUNREI = {
    a: "\u3042",
    i: "\u3044",
    u: "\u3046",
    e: "\u3048",
    o: "\u304A",
    k: {
        a: "\u304B",
        i: "\u304D",
        u: "\u304F",
        e: "\u3051",
        o: "\u3053"
    },
    s: {
        a: "\u3055",
        i: "\u3057",
        u: "\u3059",
        e: "\u305B",
        o: "\u305D"
    },
    t: {
        a: "\u305F",
        i: "\u3061",
        u: "\u3064",
        e: "\u3066",
        o: "\u3068"
    },
    n: {
        a: "\u306A",
        i: "\u306B",
        u: "\u306C",
        e: "\u306D",
        o: "\u306E"
    },
    h: {
        a: "\u306F",
        i: "\u3072",
        u: "\u3075",
        e: "\u3078",
        o: "\u307B"
    },
    m: {
        a: "\u307E",
        i: "\u307F",
        u: "\u3080",
        e: "\u3081",
        o: "\u3082"
    },
    y: {
        a: "\u3084",
        u: "\u3086",
        o: "\u3088"
    },
    r: {
        a: "\u3089",
        i: "\u308A",
        u: "\u308B",
        e: "\u308C",
        o: "\u308D"
    },
    w: {
        a: "\u308F",
        i: "\u3090",
        e: "\u3091",
        o: "\u3092"
    },
    g: {
        a: "\u304C",
        i: "\u304E",
        u: "\u3050",
        e: "\u3052",
        o: "\u3054"
    },
    z: {
        a: "\u3056",
        i: "\u3058",
        u: "\u305A",
        e: "\u305C",
        o: "\u305E"
    },
    d: {
        a: "\u3060",
        i: "\u3062",
        u: "\u3065",
        e: "\u3067",
        o: "\u3069"
    },
    b: {
        a: "\u3070",
        i: "\u3073",
        u: "\u3076",
        e: "\u3079",
        o: "\u307C"
    },
    p: {
        a: "\u3071",
        i: "\u3074",
        u: "\u3077",
        e: "\u307A",
        o: "\u307D"
    },
    v: {
        a: "\u3094\u3041",
        i: "\u3094\u3043",
        u: "\u3094",
        e: "\u3094\u3047",
        o: "\u3094\u3049"
    }
};
const $ce9158473db88422$var$SPECIAL_SYMBOLS$1 = {
    '.': "\u3002",
    ',': "\u3001",
    ':': "\uFF1A",
    '/': "\u30FB",
    '!': "\uFF01",
    '?': "\uFF1F",
    '~': "\u301C",
    '-': "\u30FC",
    "\u2018": "\u300C",
    "\u2019": "\u300D",
    "\u201C": "\u300E",
    "\u201D": "\u300F",
    '[': "\uFF3B",
    ']': "\uFF3D",
    '(': "\uFF08",
    ')': "\uFF09",
    '{': "\uFF5B",
    '}': "\uFF5D"
};
const $ce9158473db88422$var$CONSONANTS = {
    k: "\u304D",
    s: "\u3057",
    t: "\u3061",
    n: "\u306B",
    h: "\u3072",
    m: "\u307F",
    r: "\u308A",
    g: "\u304E",
    z: "\u3058",
    d: "\u3062",
    b: "\u3073",
    p: "\u3074",
    v: "\u3094",
    q: "\u304F",
    f: "\u3075"
};
const $ce9158473db88422$var$SMALL_Y$1 = {
    ya: "\u3083",
    yi: "\u3043",
    yu: "\u3085",
    ye: "\u3047",
    yo: "\u3087"
};
const $ce9158473db88422$var$SMALL_VOWELS = {
    a: "\u3041",
    i: "\u3043",
    u: "\u3045",
    e: "\u3047",
    o: "\u3049"
};
// typing one should be the same as having typed the other instead
const $ce9158473db88422$var$ALIASES = {
    sh: 'sy',
    ch: 'ty',
    cy: 'ty',
    chy: 'ty',
    shy: 'sy',
    j: 'zy',
    jy: 'zy',
    // exceptions to above rules
    shi: 'si',
    chi: 'ti',
    tsu: 'tu',
    ji: 'zi',
    fu: 'hu'
};
// xtu -> っ
const $ce9158473db88422$var$SMALL_LETTERS = Object.assign({
    tu: "\u3063",
    wa: "\u308E",
    ka: "\u30F5",
    ke: "\u30F6"
}, $ce9158473db88422$var$SMALL_VOWELS, $ce9158473db88422$var$SMALL_Y$1);
// don't follow any notable patterns
const $ce9158473db88422$var$SPECIAL_CASES = {
    yi: "\u3044",
    wu: "\u3046",
    ye: "\u3044\u3047",
    wi: "\u3046\u3043",
    we: "\u3046\u3047",
    kwa: "\u304F\u3041",
    whu: "\u3046",
    // because it's not thya for てゃ but tha
    // and tha is not てぁ, but てゃ
    tha: "\u3066\u3083",
    thu: "\u3066\u3085",
    tho: "\u3066\u3087",
    dha: "\u3067\u3083",
    dhu: "\u3067\u3085",
    dho: "\u3067\u3087"
};
const $ce9158473db88422$var$AIUEO_CONSTRUCTIONS = {
    wh: "\u3046",
    kw: "\u304F",
    qw: "\u304F",
    q: "\u304F",
    gw: "\u3050",
    sw: "\u3059",
    ts: "\u3064",
    th: "\u3066",
    tw: "\u3068",
    dh: "\u3067",
    dw: "\u3069",
    fw: "\u3075",
    f: "\u3075"
};
/* eslint-enable */ function $ce9158473db88422$var$createRomajiToKanaMap$1() {
    const kanaTree = $ce9158473db88422$var$transform($ce9158473db88422$var$BASIC_KUNREI);
    // pseudo partial application
    const subtreeOf = (string)=>$ce9158473db88422$var$getSubTreeOf(kanaTree, string);
    // add tya, sya, etc.
    Object.entries($ce9158473db88422$var$CONSONANTS).forEach(([consonant, yKana])=>{
        Object.entries($ce9158473db88422$var$SMALL_Y$1).forEach(([roma, kana])=>{
            // for example kyo -> き + ょ
            subtreeOf(consonant + roma)[''] = yKana + kana;
        });
    });
    Object.entries($ce9158473db88422$var$SPECIAL_SYMBOLS$1).forEach(([symbol, jsymbol])=>{
        subtreeOf(symbol)[''] = jsymbol;
    });
    // things like うぃ, くぃ, etc.
    Object.entries($ce9158473db88422$var$AIUEO_CONSTRUCTIONS).forEach(([consonant, aiueoKana])=>{
        Object.entries($ce9158473db88422$var$SMALL_VOWELS).forEach(([vowel, kana])=>{
            const subtree = subtreeOf(consonant + vowel);
            subtree[''] = aiueoKana + kana;
        });
    });
    // different ways to write ん
    [
        'n',
        "n'",
        'xn'
    ].forEach((nChar)=>{
        subtreeOf(nChar)[''] = "\u3093";
    });
    // c is equivalent to k, but not for chi, cha, etc. that's why we have to make a copy of k
    kanaTree.c = JSON.parse(JSON.stringify(kanaTree.k));
    Object.entries($ce9158473db88422$var$ALIASES).forEach(([string, alternative])=>{
        const allExceptLast = string.slice(0, string.length - 1);
        const last = string.charAt(string.length - 1);
        const parentTree = subtreeOf(allExceptLast);
        // copy to avoid recursive containment
        parentTree[last] = JSON.parse(JSON.stringify(subtreeOf(alternative)));
    });
    function getAlternatives(string) {
        return [
            ...Object.entries($ce9158473db88422$var$ALIASES),
            [
                'c',
                'k'
            ]
        ].reduce((list, [alt, roma])=>string.startsWith(roma) ? list.concat(string.replace(roma, alt)) : list, []);
    }
    Object.entries($ce9158473db88422$var$SMALL_LETTERS).forEach(([kunreiRoma, kana])=>{
        const last = (char)=>char.charAt(char.length - 1);
        const allExceptLast = (chars)=>chars.slice(0, chars.length - 1);
        const xRoma = `x${kunreiRoma}`;
        const xSubtree = subtreeOf(xRoma);
        xSubtree[''] = kana;
        // ltu -> xtu -> っ
        const parentTree = subtreeOf(`l${allExceptLast(kunreiRoma)}`);
        parentTree[last(kunreiRoma)] = xSubtree;
        // ltsu -> ltu -> っ
        getAlternatives(kunreiRoma).forEach((altRoma)=>{
            [
                'l',
                'x'
            ].forEach((prefix)=>{
                const altParentTree = subtreeOf(prefix + allExceptLast(altRoma));
                altParentTree[last(altRoma)] = subtreeOf(prefix + kunreiRoma);
            });
        });
    });
    Object.entries($ce9158473db88422$var$SPECIAL_CASES).forEach(([string, kana])=>{
        subtreeOf(string)[''] = kana;
    });
    // add kka, tta, etc.
    function addTsu(tree) {
        return Object.entries(tree).reduce((tsuTree, [key, value])=>{
            if (!key) // we have reached the bottom of this branch
            // eslint-disable-next-line no-param-reassign
            tsuTree[key] = `\u{3063}${value}`;
            else // more subtrees
            // eslint-disable-next-line no-param-reassign
            tsuTree[key] = addTsu(value);
            return tsuTree;
        }, {});
    }
    // have to explicitly name c here, because we made it a copy of k, not a reference
    [
        ...Object.keys($ce9158473db88422$var$CONSONANTS),
        'c',
        'y',
        'w',
        'j'
    ].forEach((consonant)=>{
        const subtree = kanaTree[consonant];
        subtree[consonant] = addTsu(subtree);
    });
    // nn should not be っん
    delete kanaTree.n.n;
    // solidify the results, so that there there is referential transparency within the tree
    return Object.freeze(JSON.parse(JSON.stringify(kanaTree)));
}
let $ce9158473db88422$var$romajiToKanaMap = null;
function $ce9158473db88422$var$getRomajiToKanaTree() {
    if ($ce9158473db88422$var$romajiToKanaMap == null) $ce9158473db88422$var$romajiToKanaMap = $ce9158473db88422$var$createRomajiToKanaMap$1();
    return $ce9158473db88422$var$romajiToKanaMap;
}
const $ce9158473db88422$var$USE_OBSOLETE_KANA_MAP = $ce9158473db88422$var$createCustomMapping({
    wi: "\u3090",
    we: "\u3091"
});
function $ce9158473db88422$var$IME_MODE_MAP(map) {
    // in IME mode, we do not want to convert single ns
    const mapCopy = JSON.parse(JSON.stringify(map));
    mapCopy.n.n = {
        '': "\u3093"
    };
    mapCopy.n[' '] = {
        '': "\u3093"
    };
    return mapCopy;
}
/**
 * Tests if char is in English unicode uppercase range
 * @param  {String} char
 * @return {Boolean}
 */ function $ce9158473db88422$var$isCharUpperCase(char = '') {
    if ($ce9158473db88422$var$isEmpty(char)) return false;
    return $ce9158473db88422$var$isCharInRange(char, $ce9158473db88422$var$LATIN_UPPERCASE_START, $ce9158473db88422$var$LATIN_UPPERCASE_END);
}
/**
 * Returns true if char is 'ー'
 * @param  {String} char to test
 * @return {Boolean}
 */ function $ce9158473db88422$var$isCharLongDash(char = '') {
    if ($ce9158473db88422$var$isEmpty(char)) return false;
    return char.charCodeAt(0) === $ce9158473db88422$var$PROLONGED_SOUND_MARK;
}
/**
 * Tests if char is '・'
 * @param  {String} char
 * @return {Boolean} true if '・'
 */ function $ce9158473db88422$var$isCharSlashDot(char = '') {
    if ($ce9158473db88422$var$isEmpty(char)) return false;
    return char.charCodeAt(0) === $ce9158473db88422$var$KANA_SLASH_DOT;
}
/**
 * Tests a character. Returns true if the character is [Hiragana](https://en.wikipedia.org/wiki/Hiragana).
 * @param  {String} char character string to test
 * @return {Boolean}
 */ function $ce9158473db88422$var$isCharHiragana(char = '') {
    if ($ce9158473db88422$var$isEmpty(char)) return false;
    if ($ce9158473db88422$var$isCharLongDash(char)) return true;
    return $ce9158473db88422$var$isCharInRange(char, $ce9158473db88422$var$HIRAGANA_START, $ce9158473db88422$var$HIRAGANA_END);
}
/**
 * Convert [Hiragana](https://en.wikipedia.org/wiki/Hiragana) to [Katakana](https://en.wikipedia.org/wiki/Katakana)
 * Passes through any non-hiragana chars
 * @private
 * @param  {String} [input=''] text input
 * @return {String} converted text
 * @example
 * hiraganaToKatakana('ひらがな')
 * // => "ヒラガナ"
 * hiraganaToKatakana('ひらがな is a type of kana')
 * // => "ヒラガナ is a type of kana"
 */ function $ce9158473db88422$var$hiraganaToKatakana(input = '') {
    const kata = [];
    input.split('').forEach((char)=>{
        // Short circuit to avoid incorrect codeshift for 'ー' and '・'
        if ($ce9158473db88422$var$isCharLongDash(char) || $ce9158473db88422$var$isCharSlashDot(char)) kata.push(char);
        else if ($ce9158473db88422$var$isCharHiragana(char)) {
            // Shift charcode.
            const code = char.charCodeAt(0) + ($ce9158473db88422$var$KATAKANA_START - $ce9158473db88422$var$HIRAGANA_START);
            const kataChar = String.fromCharCode(code);
            kata.push(kataChar);
        } else // Pass non-hiragana chars through
        kata.push(char);
    });
    return kata.join('');
}
// memoize and deeply compare args so we only recreate when necessary
const $ce9158473db88422$var$createRomajiToKanaMap = $ce9158473db88422$var$memoizeOne((IMEMode, useObsoleteKana, customKanaMapping)=>{
    let map = $ce9158473db88422$var$getRomajiToKanaTree();
    map = IMEMode ? $ce9158473db88422$var$IME_MODE_MAP(map) : map;
    map = useObsoleteKana ? $ce9158473db88422$var$USE_OBSOLETE_KANA_MAP(map) : map;
    if (customKanaMapping) map = $ce9158473db88422$var$mergeCustomMapping(map, customKanaMapping);
    return map;
}, $ce9158473db88422$var$dequal);
/**
 * Convert [Romaji](https://en.wikipedia.org/wiki/Romaji) to [Kana](https://en.wikipedia.org/wiki/Kana), lowercase text will result in [Hiragana](https://en.wikipedia.org/wiki/Hiragana) and uppercase text will result in [Katakana](https://en.wikipedia.org/wiki/Katakana).
 * @param  {String} [input=''] text
 * @param  {DefaultOptions} [options=defaultOptions]
 * @param  {Object.<string, string>} [map] custom mapping
 * @return {String} converted text
 * @example
 * toKana('onaji BUTTSUUJI')
 * // => 'おなじ ブッツウジ'
 * toKana('ONAJI buttsuuji')
 * // => 'オナジ ぶっつうじ'
 * toKana('座禅‘zazen’スタイル')
 * // => '座禅「ざぜん」スタイル'
 * toKana('batsuge-mu')
 * // => 'ばつげーむ'
 * toKana('!?.:/,~-‘’“”[](){}') // Punctuation conversion
 * // => '！？。：・、〜ー「」『』［］（）｛｝'
 * toKana('we', { useObsoleteKana: true })
 * // => 'ゑ'
 * toKana('wanakana', { customKanaMapping: { na: 'に', ka: 'bana' } });
 * // => 'わにbanaに'
 */ function $ce9158473db88422$export$4973add5c59f0c7b(input = '', options = {}, map) {
    let config;
    if (!map) {
        config = $ce9158473db88422$var$mergeWithDefaultOptions(options);
        map = $ce9158473db88422$var$createRomajiToKanaMap(config.IMEMode, config.useObsoleteKana, config.customKanaMapping);
    } else config = options;
    // throw away the substring index information and just concatenate all the kana
    return $ce9158473db88422$var$splitIntoConvertedKana(input, config, map).map((kanaToken)=>{
        const [start, end, kana] = kanaToken;
        if (kana === null) // haven't converted the end of the string, since we are in IME mode
        return input.slice(start);
        const enforceHiragana = config.IMEMode === $ce9158473db88422$export$4cb93ec9ed11137c.HIRAGANA;
        const enforceKatakana = config.IMEMode === $ce9158473db88422$export$4cb93ec9ed11137c.KATAKANA || [
            ...input.slice(start, end)
        ].every($ce9158473db88422$var$isCharUpperCase);
        return enforceHiragana || !enforceKatakana ? kana : $ce9158473db88422$var$hiraganaToKatakana(kana);
    }).join('');
}
/**
 *
 * @private
 * @param {String} [input=''] input text
 * @param {DefaultOptions} [options=defaultOptions] toKana options
 * @param {Object} [map] custom mapping
 * @returns {Array[]} [[start, end, token]]
 * @example
 * splitIntoConvertedKana('buttsuuji')
 * // => [[0, 2, 'ぶ'], [2, 6, 'っつ'], [6, 7, 'う'], [7, 9, 'じ']]
 */ function $ce9158473db88422$var$splitIntoConvertedKana(input = '', options = {}, map) {
    const { IMEMode: IMEMode, useObsoleteKana: useObsoleteKana, customKanaMapping: customKanaMapping } = options;
    if (!map) map = $ce9158473db88422$var$createRomajiToKanaMap(IMEMode, useObsoleteKana, customKanaMapping);
    return $ce9158473db88422$var$applyMapping(input.toLowerCase(), map, !IMEMode);
}
let $ce9158473db88422$var$LISTENERS = [];
/**
 * Automagically replaces input values with converted text to kana
 * @param  {defaultOptions} [options] user config overrides, default conversion is toKana()
 * @return {Function} event handler with bound options
 * @private
 */ function $ce9158473db88422$var$makeOnInput(options) {
    let prevInput;
    // Enforce IMEMode if not already specified
    const mergedConfig = Object.assign({}, $ce9158473db88422$var$mergeWithDefaultOptions(options), {
        IMEMode: options.IMEMode || true
    });
    const preConfiguredMap = $ce9158473db88422$var$createRomajiToKanaMap(mergedConfig.IMEMode, mergedConfig.useObsoleteKana, mergedConfig.customKanaMapping);
    const triggers = [
        ...Object.keys(preConfiguredMap),
        ...Object.keys(preConfiguredMap).map((char)=>char.toUpperCase())
    ];
    return function onInput({ target: target }) {
        if (target.value !== prevInput && target.dataset.ignoreComposition !== 'true') $ce9158473db88422$var$convertInput(target, mergedConfig, preConfiguredMap, triggers);
    };
}
function $ce9158473db88422$var$convertInput(target, options, map, triggers, prevInput) {
    const [head, textToConvert, tail] = $ce9158473db88422$var$splitInput(target.value, target.selectionEnd, triggers);
    const convertedText = $ce9158473db88422$export$4973add5c59f0c7b(textToConvert, options, map);
    const changed = textToConvert !== convertedText;
    if (changed) {
        const newCursor = head.length + convertedText.length;
        const newValue = head + convertedText + tail;
        // eslint-disable-next-line no-param-reassign
        target.value = newValue;
        if (tail.length) // push later on event loop (otherwise mid-text insertion can be 1 char too far to the right)
        setTimeout(()=>target.setSelectionRange(newCursor, newCursor), 1);
        else target.setSelectionRange(newCursor, newCursor);
    } else // eslint-disable-next-line no-param-reassign
    target.value;
}
function $ce9158473db88422$var$onComposition({ type: type, target: target, data: data }) {
    // navigator.platform is not 100% reliable for singling out all OS,
    // but for determining desktop "Mac OS" it is effective enough.
    const isMacOS = /Mac/.test(window.navigator && window.navigator.platform);
    // We don't want to ignore on Android:
    // https://github.com/WaniKani/WanaKana/issues/82
    // But MacOS IME auto-closes if we don't ignore:
    // https://github.com/WaniKani/WanaKana/issues/71
    // Other platform Japanese IMEs pass through happily
    if (isMacOS) {
        if (type === 'compositionupdate' && $ce9158473db88422$export$33dfa193fc452c06(data)) // eslint-disable-next-line no-param-reassign
        target.dataset.ignoreComposition = 'true';
        if (type === 'compositionend') // eslint-disable-next-line no-param-reassign
        target.dataset.ignoreComposition = 'false';
    }
}
function $ce9158473db88422$var$trackListeners(id, inputHandler, compositionHandler) {
    $ce9158473db88422$var$LISTENERS = $ce9158473db88422$var$LISTENERS.concat({
        id: id,
        inputHandler: inputHandler,
        compositionHandler: compositionHandler
    });
}
function $ce9158473db88422$var$untrackListeners({ id: targetId }) {
    $ce9158473db88422$var$LISTENERS = $ce9158473db88422$var$LISTENERS.filter(({ id: id })=>id !== targetId);
}
function $ce9158473db88422$var$findListeners(el) {
    return el && $ce9158473db88422$var$LISTENERS.find(({ id: id })=>id === el.getAttribute('data-wanakana-id'));
}
// Handle non-terminal inserted input conversion:
// | -> わ| -> わび| -> わ|び -> わs|び -> わsh|び -> わshi|び -> わし|び
// or multiple ambiguous positioning (to select which "s" to work from)
// こsこs|こsこ -> こsこso|こsこ -> こsこそ|こsこ
function $ce9158473db88422$var$splitInput(text = '', cursor = 0, triggers = []) {
    let head;
    let toConvert;
    let tail;
    if (cursor === 0 && triggers.includes(text[0])) [head, toConvert, tail] = $ce9158473db88422$var$workFromStart(text, triggers);
    else if (cursor > 0) [head, toConvert, tail] = $ce9158473db88422$var$workBackwards(text, cursor);
    else {
        [head, toConvert] = $ce9158473db88422$var$takeWhileAndSlice(text, (char)=>!triggers.includes(char));
        [toConvert, tail] = $ce9158473db88422$var$takeWhileAndSlice(toConvert, (char)=>!$ce9158473db88422$export$33dfa193fc452c06(char));
    }
    return [
        head,
        toConvert,
        tail
    ];
}
function $ce9158473db88422$var$workFromStart(text, catalystChars) {
    return [
        '',
        ...$ce9158473db88422$var$takeWhileAndSlice(text, (char)=>catalystChars.includes(char) || !$ce9158473db88422$export$33dfa193fc452c06(char, /[0-9]/))
    ];
}
function $ce9158473db88422$var$workBackwards(text = '', startIndex = 0) {
    const [toConvert, head] = $ce9158473db88422$var$takeWhileAndSlice([
        ...text.slice(0, startIndex)
    ].reverse(), (char)=>!$ce9158473db88422$export$33dfa193fc452c06(char));
    return [
        head.reverse().join(''),
        toConvert.split('').reverse().join(''),
        text.slice(startIndex)
    ];
}
function $ce9158473db88422$var$takeWhileAndSlice(source = {}, predicate = (x)=>!!x) {
    const result = [];
    const { length: length } = source;
    let i = 0;
    while(i < length && predicate(source[i], i)){
        result.push(source[i]);
        i += 1;
    }
    return [
        result.join(''),
        source.slice(i)
    ];
}
/* eslint-disable no-console */ const $ce9158473db88422$var$onInput = ({ target: { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } })=>console.log('input:', {
        value: value,
        selectionStart: selectionStart,
        selectionEnd: selectionEnd
    });
const $ce9158473db88422$var$onCompositionStart = ()=>console.log('compositionstart');
const $ce9158473db88422$var$onCompositionUpdate = ({ target: { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd }, data: data })=>console.log('compositionupdate', {
        data: data,
        value: value,
        selectionStart: selectionStart,
        selectionEnd: selectionEnd
    });
const $ce9158473db88422$var$onCompositionEnd = ()=>console.log('compositionend');
const $ce9158473db88422$var$events = {
    input: $ce9158473db88422$var$onInput,
    compositionstart: $ce9158473db88422$var$onCompositionStart,
    compositionupdate: $ce9158473db88422$var$onCompositionUpdate,
    compositionend: $ce9158473db88422$var$onCompositionEnd
};
const $ce9158473db88422$var$addDebugListeners = (input)=>{
    Object.entries($ce9158473db88422$var$events).forEach(([event, handler])=>input.addEventListener(event, handler));
};
const $ce9158473db88422$var$removeDebugListeners = (input)=>{
    Object.entries($ce9158473db88422$var$events).forEach(([event, handler])=>input.removeEventListener(event, handler));
};
const $ce9158473db88422$var$ELEMENTS = [
    'TEXTAREA',
    'INPUT'
];
let $ce9158473db88422$var$idCounter = 0;
const $ce9158473db88422$var$newId = ()=>{
    $ce9158473db88422$var$idCounter += 1;
    return `${Date.now()}${$ce9158473db88422$var$idCounter}`;
};
/**
 * Binds eventListener for 'input' events to an input field to automagically replace values with kana
 * Can pass `{ IMEMode: 'toHiragana' || 'toKatakana' }` to enforce kana conversion type
 * @param  {HTMLInputElement | HTMLTextAreaElement} element textarea, input[type="text"] etc
 * @param  {DefaultOptions} [options=defaultOptions] defaults to { IMEMode: true } using `toKana`
 * @example
 * bind(document.querySelector('#myInput'));
 */ function $ce9158473db88422$export$2385a24977818dd0(element = {}, options = {}, debug = false) {
    if (!$ce9158473db88422$var$ELEMENTS.includes(element.nodeName)) throw new Error(`Element provided to Wanakana bind() was not a valid input or textarea element.\n Received: (${JSON.stringify(element)})`);
    if (element.hasAttribute('data-wanakana-id')) return;
    const onInput = $ce9158473db88422$var$makeOnInput(options);
    const id = $ce9158473db88422$var$newId();
    const attributes = [
        {
            name: 'data-wanakana-id',
            value: id
        },
        {
            name: 'lang',
            value: 'ja'
        },
        {
            name: 'autoCapitalize',
            value: 'none'
        },
        {
            name: 'autoCorrect',
            value: 'off'
        },
        {
            name: 'autoComplete',
            value: 'off'
        },
        {
            name: 'spellCheck',
            value: 'false'
        }
    ];
    const previousAttributes = {};
    attributes.forEach((attribute)=>{
        previousAttributes[attribute.name] = element.getAttribute(attribute.name);
        element.setAttribute(attribute.name, attribute.value);
    });
    element.dataset.previousAttributes = JSON.stringify(previousAttributes);
    element.addEventListener('input', onInput);
    element.addEventListener('compositionupdate', $ce9158473db88422$var$onComposition);
    element.addEventListener('compositionend', $ce9158473db88422$var$onComposition);
    $ce9158473db88422$var$trackListeners(id, onInput, $ce9158473db88422$var$onComposition);
    if (debug === true) $ce9158473db88422$var$addDebugListeners(element);
}
/**
 * Unbinds eventListener from input field
 * @param  {HTMLInputElement | HTMLTextAreaElement} element textarea, input
 */ function $ce9158473db88422$export$433e98592e7124fd(element, debug = false) {
    const listeners = $ce9158473db88422$var$findListeners(element);
    if (listeners == null) throw new Error(`Element provided to Wanakana unbind() had no listener registered.\n Received: ${JSON.stringify(element)}`);
    const { inputHandler: inputHandler, compositionHandler: compositionHandler } = listeners;
    const attributes = JSON.parse(element.dataset.previousAttributes);
    Object.keys(attributes).forEach((key)=>{
        if (attributes[key]) element.setAttribute(key, attributes[key]);
        else element.removeAttribute(key);
    });
    element.removeAttribute('data-previous-attributes');
    element.removeAttribute('data-ignore-composition');
    element.removeEventListener('input', inputHandler);
    element.removeEventListener('compositionstart', compositionHandler);
    element.removeEventListener('compositionupdate', compositionHandler);
    element.removeEventListener('compositionend', compositionHandler);
    $ce9158473db88422$var$untrackListeners(listeners);
    if (debug === true) $ce9158473db88422$var$removeDebugListeners(element);
}
/**
 * Tests a character. Returns true if the character is [Romaji](https://en.wikipedia.org/wiki/Romaji) (allowing [Hepburn romanisation](https://en.wikipedia.org/wiki/Hepburn_romanization))
 * @param  {String} char character string to test
 * @return {Boolean}
 */ function $ce9158473db88422$var$isCharRomaji(char = '') {
    if ($ce9158473db88422$var$isEmpty(char)) return false;
    return $ce9158473db88422$var$ROMAJI_RANGES.some(([start, end])=>$ce9158473db88422$var$isCharInRange(char, start, end));
}
/**
 * Test if `input` is [Romaji](https://en.wikipedia.org/wiki/Romaji) (allowing [Hepburn romanisation](https://en.wikipedia.org/wiki/Hepburn_romanization))
 * @param  {String} [input=''] text
 * @param  {RegExp} [allowed] additional test allowed to pass for each char
 * @return {Boolean} true if [Romaji](https://en.wikipedia.org/wiki/Romaji)
 * @example
 * isRomaji('Tōkyō and Ōsaka')
 * // => true
 * isRomaji('12a*b&c-d')
 * // => true
 * isRomaji('あアA')
 * // => false
 * isRomaji('お願い')
 * // => false
 * isRomaji('a！b&cーd') // Zenkaku punctuation fails
 * // => false
 * isRomaji('a！b&cーd', /[！ー]/)
 * // => true
 */ function $ce9158473db88422$export$28956e30362f46cb(input = '', allowed) {
    const augmented = $ce9158473db88422$var$typeOf(allowed) === 'regexp';
    return $ce9158473db88422$var$isEmpty(input) ? false : [
        ...input
    ].every((char)=>{
        const isRoma = $ce9158473db88422$var$isCharRomaji(char);
        return !augmented ? isRoma : isRoma || allowed.test(char);
    });
}
/**
 * Tests a character. Returns true if the character is [Katakana](https://en.wikipedia.org/wiki/Katakana).
 * @param  {String} char character string to test
 * @return {Boolean}
 */ function $ce9158473db88422$var$isCharKatakana(char = '') {
    return $ce9158473db88422$var$isCharInRange(char, $ce9158473db88422$var$KATAKANA_START, $ce9158473db88422$var$KATAKANA_END);
}
/**
 * Tests a character. Returns true if the character is [Hiragana](https://en.wikipedia.org/wiki/Hiragana) or [Katakana](https://en.wikipedia.org/wiki/Katakana).
 * @param  {String} char character string to test
 * @return {Boolean}
 */ function $ce9158473db88422$var$isCharKana(char = '') {
    if ($ce9158473db88422$var$isEmpty(char)) return false;
    return $ce9158473db88422$var$isCharHiragana(char) || $ce9158473db88422$var$isCharKatakana(char);
}
/**
 * Test if `input` is [Kana](https://en.wikipedia.org/wiki/Kana) ([Katakana](https://en.wikipedia.org/wiki/Katakana) and/or [Hiragana](https://en.wikipedia.org/wiki/Hiragana))
 * @param  {String} [input=''] text
 * @return {Boolean} true if all [Kana](https://en.wikipedia.org/wiki/Kana)
 * @example
 * isKana('あ')
 * // => true
 * isKana('ア')
 * // => true
 * isKana('あーア')
 * // => true
 * isKana('A')
 * // => false
 * isKana('あAア')
 * // => false
 */ function $ce9158473db88422$export$89c35efdd540c5db(input = '') {
    if ($ce9158473db88422$var$isEmpty(input)) return false;
    return [
        ...input
    ].every($ce9158473db88422$var$isCharKana);
}
/**
 * Test if `input` is [Hiragana](https://en.wikipedia.org/wiki/Hiragana)
 * @param  {String} [input=''] text
 * @return {Boolean} true if all [Hiragana](https://en.wikipedia.org/wiki/Hiragana)
 * @example
 * isHiragana('げーむ')
 * // => true
 * isHiragana('A')
 * // => false
 * isHiragana('あア')
 * // => false
 */ function $ce9158473db88422$export$564fffeb22be4c11(input = '') {
    if ($ce9158473db88422$var$isEmpty(input)) return false;
    return [
        ...input
    ].every($ce9158473db88422$var$isCharHiragana);
}
/**
 * Test if `input` is [Katakana](https://en.wikipedia.org/wiki/Katakana)
 * @param  {String} [input=''] text
 * @return {Boolean} true if all [Katakana](https://en.wikipedia.org/wiki/Katakana)
 * @example
 * isKatakana('ゲーム')
 * // => true
 * isKatakana('あ')
 * // => false
 * isKatakana('A')
 * // => false
 * isKatakana('あア')
 * // => false
 */ function $ce9158473db88422$export$9565d2ed9558b472(input = '') {
    if ($ce9158473db88422$var$isEmpty(input)) return false;
    return [
        ...input
    ].every($ce9158473db88422$var$isCharKatakana);
}
/**
 * Returns true if char is '々'
 * @param  {String} char to test
 * @return {Boolean}
 */ function $ce9158473db88422$var$isCharIterationMark(char = '') {
    if ($ce9158473db88422$var$isEmpty(char)) return false;
    return char.charCodeAt(0) === $ce9158473db88422$var$KANJI_ITERATION_MARK;
}
/**
 * Tests a character. Returns true if the character is a CJK ideograph (kanji).
 * @param  {String} char character string to test
 * @return {Boolean}
 */ function $ce9158473db88422$var$isCharKanji(char = '') {
    return $ce9158473db88422$var$isCharInRange(char, $ce9158473db88422$var$KANJI_START, $ce9158473db88422$var$KANJI_END) || $ce9158473db88422$var$isCharIterationMark(char);
}
/**
 * Tests if `input` is [Kanji](https://en.wikipedia.org/wiki/Kanji) ([Japanese CJK ideographs](https://en.wikipedia.org/wiki/CJK_Unified_Ideographs))
 * @param  {String} [input=''] text
 * @return {Boolean} true if all [Kanji](https://en.wikipedia.org/wiki/Kanji)
 * @example
 * isKanji('刀')
 * // => true
 * isKanji('切腹')
 * // => true
 * isKanji('勢い')
 * // => false
 * isKanji('あAア')
 * // => false
 * isKanji('🐸')
 * // => false
 */ function $ce9158473db88422$export$92376b026946860f(input = '') {
    if ($ce9158473db88422$var$isEmpty(input)) return false;
    return [
        ...input
    ].every($ce9158473db88422$var$isCharKanji);
}
/**
 * Test if `input` contains a mix of [Romaji](https://en.wikipedia.org/wiki/Romaji) *and* [Kana](https://en.wikipedia.org/wiki/Kana), defaults to pass through [Kanji](https://en.wikipedia.org/wiki/Kanji)
 * @param  {String} input text
 * @param  {{ passKanji: Boolean}} [options={ passKanji: true }] optional config to pass through kanji
 * @return {Boolean} true if mixed
 * @example
 * isMixed('Abあア'))
 * // => true
 * isMixed('お腹A')) // ignores kanji by default
 * // => true
 * isMixed('お腹A', { passKanji: false }))
 * // => false
 * isMixed('ab'))
 * // => false
 * isMixed('あア'))
 * // => false
 */ function $ce9158473db88422$export$e534968524b67a52(input = '', options = {
    passKanji: true
}) {
    const chars = [
        ...input
    ];
    let hasKanji = false;
    if (!options.passKanji) hasKanji = chars.some($ce9158473db88422$export$92376b026946860f);
    return (chars.some($ce9158473db88422$export$564fffeb22be4c11) || chars.some($ce9158473db88422$export$9565d2ed9558b472)) && chars.some($ce9158473db88422$export$28956e30362f46cb) && !hasKanji;
}
const $ce9158473db88422$var$isCharInitialLongDash = (char, index)=>$ce9158473db88422$var$isCharLongDash(char) && index < 1;
const $ce9158473db88422$var$isCharInnerLongDash = (char, index)=>$ce9158473db88422$var$isCharLongDash(char) && index > 0;
const $ce9158473db88422$var$isKanaAsSymbol = (char)=>[
        "\u30F6",
        "\u30F5"
    ].includes(char);
const $ce9158473db88422$var$LONG_VOWELS = {
    a: "\u3042",
    i: "\u3044",
    u: "\u3046",
    e: "\u3048",
    o: "\u3046"
};
// inject toRomaji to avoid circular dependency between toRomaji <-> katakanaToHiragana
function $ce9158473db88422$var$katakanaToHiragana(input = '', toRomaji, { isDestinationRomaji: isDestinationRomaji, convertLongVowelMark: convertLongVowelMark } = {}) {
    let previousKana = '';
    return input.split('').reduce((hira, char, index)=>{
        // Short circuit to avoid incorrect codeshift for 'ー' and '・'
        if ($ce9158473db88422$var$isCharSlashDot(char) || $ce9158473db88422$var$isCharInitialLongDash(char, index) || $ce9158473db88422$var$isKanaAsSymbol(char)) return hira.concat(char);
        // Transform long vowels: 'オー' to 'おう'
        if (convertLongVowelMark && previousKana && $ce9158473db88422$var$isCharInnerLongDash(char, index)) {
            // Transform previousKana back to romaji, and slice off the vowel
            const romaji = toRomaji(previousKana).slice(-1);
            // However, ensure 'オー' => 'おお' => 'oo' if this is a transform on the way to romaji
            if ($ce9158473db88422$var$isCharKatakana(input[index - 1]) && romaji === 'o' && isDestinationRomaji) return hira.concat("\u304A");
            return hira.concat($ce9158473db88422$var$LONG_VOWELS[romaji]);
        // Transform all other chars
        }
        if (!$ce9158473db88422$var$isCharLongDash(char) && $ce9158473db88422$var$isCharKatakana(char)) {
            const code = char.charCodeAt(0) + ($ce9158473db88422$var$HIRAGANA_START - $ce9158473db88422$var$KATAKANA_START);
            const hiraChar = String.fromCharCode(code);
            previousKana = hiraChar;
            return hira.concat(hiraChar);
        }
        // Pass non katakana chars through
        previousKana = '';
        return hira.concat(char);
    }, []).join('');
}
let $ce9158473db88422$var$kanaToHepburnMap = null;
/* eslint-disable */ // prettier-ignore
const $ce9158473db88422$var$BASIC_ROMAJI = {
    \u3042: 'a',
    \u3044: 'i',
    \u3046: 'u',
    \u3048: 'e',
    \u304A: 'o',
    \u304B: 'ka',
    \u304D: 'ki',
    \u304F: 'ku',
    \u3051: 'ke',
    \u3053: 'ko',
    \u3055: 'sa',
    \u3057: 'shi',
    \u3059: 'su',
    \u305B: 'se',
    \u305D: 'so',
    \u305F: 'ta',
    \u3061: 'chi',
    \u3064: 'tsu',
    \u3066: 'te',
    \u3068: 'to',
    \u306A: 'na',
    \u306B: 'ni',
    \u306C: 'nu',
    \u306D: 'ne',
    \u306E: 'no',
    \u306F: 'ha',
    \u3072: 'hi',
    \u3075: 'fu',
    \u3078: 'he',
    \u307B: 'ho',
    \u307E: 'ma',
    \u307F: 'mi',
    \u3080: 'mu',
    \u3081: 'me',
    \u3082: 'mo',
    \u3089: 'ra',
    \u308A: 'ri',
    \u308B: 'ru',
    \u308C: 're',
    \u308D: 'ro',
    \u3084: 'ya',
    \u3086: 'yu',
    \u3088: 'yo',
    \u308F: 'wa',
    \u3090: 'wi',
    \u3091: 'we',
    \u3092: 'wo',
    \u3093: 'n',
    \u304C: 'ga',
    \u304E: 'gi',
    \u3050: 'gu',
    \u3052: 'ge',
    \u3054: 'go',
    \u3056: 'za',
    \u3058: 'ji',
    \u305A: 'zu',
    \u305C: 'ze',
    \u305E: 'zo',
    \u3060: 'da',
    \u3062: 'ji',
    \u3065: 'zu',
    \u3067: 'de',
    \u3069: 'do',
    \u3070: 'ba',
    \u3073: 'bi',
    \u3076: 'bu',
    \u3079: 'be',
    \u307C: 'bo',
    \u3071: 'pa',
    \u3074: 'pi',
    \u3077: 'pu',
    \u307A: 'pe',
    \u307D: 'po',
    \u3094\u3041: 'va',
    \u3094\u3043: 'vi',
    \u3094: 'vu',
    \u3094\u3047: 've',
    \u3094\u3049: 'vo'
};
/* eslint-enable  */ const $ce9158473db88422$var$SPECIAL_SYMBOLS = {
    "\u3002": '.',
    "\u3001": ',',
    "\uFF1A": ':',
    "\u30FB": '/',
    "\uFF01": '!',
    "\uFF1F": '?',
    "\u301C": '~',
    "\u30FC": '-',
    "\u300C": "\u2018",
    "\u300D": "\u2019",
    "\u300E": "\u201C",
    "\u300F": "\u201D",
    "\uFF3B": '[',
    "\uFF3D": ']',
    "\uFF08": '(',
    "\uFF09": ')',
    "\uFF5B": '{',
    "\uFF5D": '}',
    "\u3000": ' '
};
// んい -> n'i
const $ce9158473db88422$var$AMBIGUOUS_VOWELS = [
    "\u3042",
    "\u3044",
    "\u3046",
    "\u3048",
    "\u304A",
    "\u3084",
    "\u3086",
    "\u3088"
];
const $ce9158473db88422$var$SMALL_Y = {
    \u3083: 'ya',
    \u3085: 'yu',
    \u3087: 'yo'
};
const $ce9158473db88422$var$SMALL_Y_EXTRA = {
    \u3043: 'yi',
    \u3047: 'ye'
};
const $ce9158473db88422$var$SMALL_AIUEO = {
    \u3041: 'a',
    \u3043: 'i',
    \u3045: 'u',
    \u3047: 'e',
    \u3049: 'o'
};
const $ce9158473db88422$var$YOON_KANA = [
    "\u304D",
    "\u306B",
    "\u3072",
    "\u307F",
    "\u308A",
    "\u304E",
    "\u3073",
    "\u3074",
    "\u3094",
    "\u304F",
    "\u3075"
];
const $ce9158473db88422$var$YOON_EXCEPTIONS = {
    \u3057: 'sh',
    \u3061: 'ch',
    \u3058: 'j',
    \u3062: 'j'
};
const $ce9158473db88422$var$SMALL_KANA = {
    \u3063: '',
    \u3083: 'ya',
    \u3085: 'yu',
    \u3087: 'yo',
    \u3041: 'a',
    \u3043: 'i',
    \u3045: 'u',
    \u3047: 'e',
    \u3049: 'o'
};
// going with the intuitive (yet incorrect) solution where っや -> yya and っぃ -> ii
// in other words, just assume the sokuon could have been applied to anything
const $ce9158473db88422$var$SOKUON_WHITELIST = {
    b: 'b',
    c: 't',
    d: 'd',
    f: 'f',
    g: 'g',
    h: 'h',
    j: 'j',
    k: 'k',
    m: 'm',
    p: 'p',
    q: 'q',
    r: 'r',
    s: 's',
    t: 't',
    v: 'v',
    w: 'w',
    x: 'x',
    z: 'z'
};
function $ce9158473db88422$var$getKanaToHepburnTree() {
    if ($ce9158473db88422$var$kanaToHepburnMap == null) $ce9158473db88422$var$kanaToHepburnMap = $ce9158473db88422$var$createKanaToHepburnMap();
    return $ce9158473db88422$var$kanaToHepburnMap;
}
function $ce9158473db88422$var$getKanaToRomajiTree(romanization) {
    switch(romanization){
        case $ce9158473db88422$export$9b45cb7ce8e39e14.HEPBURN:
            return $ce9158473db88422$var$getKanaToHepburnTree();
        default:
            return {};
    }
}
function $ce9158473db88422$var$createKanaToHepburnMap() {
    const romajiTree = $ce9158473db88422$var$transform($ce9158473db88422$var$BASIC_ROMAJI);
    const subtreeOf = (string)=>$ce9158473db88422$var$getSubTreeOf(romajiTree, string);
    const setTrans = (string, transliteration)=>{
        subtreeOf(string)[''] = transliteration;
    };
    Object.entries($ce9158473db88422$var$SPECIAL_SYMBOLS).forEach(([jsymbol, symbol])=>{
        subtreeOf(jsymbol)[''] = symbol;
    });
    [
        ...Object.entries($ce9158473db88422$var$SMALL_Y),
        ...Object.entries($ce9158473db88422$var$SMALL_AIUEO)
    ].forEach(([roma, kana])=>{
        setTrans(roma, kana);
    });
    // きゃ -> kya
    $ce9158473db88422$var$YOON_KANA.forEach((kana)=>{
        const firstRomajiChar = subtreeOf(kana)[''][0];
        Object.entries($ce9158473db88422$var$SMALL_Y).forEach(([yKana, yRoma])=>{
            setTrans(kana + yKana, firstRomajiChar + yRoma);
        });
        // きぃ -> kyi
        Object.entries($ce9158473db88422$var$SMALL_Y_EXTRA).forEach(([yKana, yRoma])=>{
            setTrans(kana + yKana, firstRomajiChar + yRoma);
        });
    });
    Object.entries($ce9158473db88422$var$YOON_EXCEPTIONS).forEach(([kana, roma])=>{
        // じゃ -> ja
        Object.entries($ce9158473db88422$var$SMALL_Y).forEach(([yKana, yRoma])=>{
            setTrans(kana + yKana, roma + yRoma[1]);
        });
        // じぃ -> jyi, じぇ -> je
        setTrans(`${kana}\u{3043}`, `${roma}yi`);
        setTrans(`${kana}\u{3047}`, `${roma}e`);
    });
    romajiTree["\u3063"] = $ce9158473db88422$var$resolveTsu(romajiTree);
    Object.entries($ce9158473db88422$var$SMALL_KANA).forEach(([kana, roma])=>{
        setTrans(kana, roma);
    });
    $ce9158473db88422$var$AMBIGUOUS_VOWELS.forEach((kana)=>{
        setTrans(`\u{3093}${kana}`, `n'${subtreeOf(kana)['']}`);
    });
    // NOTE: could be re-enabled with an option?
    // // んば -> mbo
    // const LABIAL = [
    //   'ば', 'び', 'ぶ', 'べ', 'ぼ',
    //   'ぱ', 'ぴ', 'ぷ', 'ぺ', 'ぽ',
    //   'ま', 'み', 'む', 'め', 'も',
    // ];
    // LABIAL.forEach((kana) => {
    //   setTrans(`ん${kana}`, `m${subtreeOf(kana)['']}`);
    // });
    return Object.freeze(JSON.parse(JSON.stringify(romajiTree)));
}
function $ce9158473db88422$var$resolveTsu(tree) {
    return Object.entries(tree).reduce((tsuTree, [key, value])=>{
        if (!key) {
            // we have reached the bottom of this branch
            const consonant = value.charAt(0);
            // eslint-disable-next-line no-param-reassign
            tsuTree[key] = Object.keys($ce9158473db88422$var$SOKUON_WHITELIST).includes(consonant) ? $ce9158473db88422$var$SOKUON_WHITELIST[consonant] + value : value;
        } else // more subtrees
        // eslint-disable-next-line no-param-reassign
        tsuTree[key] = $ce9158473db88422$var$resolveTsu(value);
        return tsuTree;
    }, {});
}
// memoize and deeply compare args so we only recreate when necessary
const $ce9158473db88422$var$createKanaToRomajiMap = $ce9158473db88422$var$memoizeOne((romanization, customRomajiMapping)=>{
    let map = $ce9158473db88422$var$getKanaToRomajiTree(romanization);
    if (customRomajiMapping) map = $ce9158473db88422$var$mergeCustomMapping(map, customRomajiMapping);
    return map;
}, $ce9158473db88422$var$dequal);
/**
 * Convert kana to romaji
 * @param  {String} kana text input
 * @param  {DefaultOptions} [options=defaultOptions]
 * @param  {Object.<string, string>} [map] custom mapping
 * @return {String} converted text
 * @example
 * toRomaji('ひらがな　カタカナ')
 * // => 'hiragana katakana'
 * toRomaji('げーむ　ゲーム')
 * // => 'ge-mu geemu'
 * toRomaji('ひらがな　カタカナ', { upcaseKatakana: true })
 * // => 'hiragana KATAKANA'
 * toRomaji('つじぎり', { customRomajiMapping: { じ: 'zi', つ: 'tu', り: 'li' } });
 * // => 'tuzigili'
 */ function $ce9158473db88422$export$b0fffd8625644e57(input = '', options = {}, map) {
    const config = $ce9158473db88422$var$mergeWithDefaultOptions(options);
    if (!map) map = $ce9158473db88422$var$createKanaToRomajiMap(config.romanization, config.customRomajiMapping);
    // just throw away the substring index information and simply concatenate all the kana
    return $ce9158473db88422$var$splitIntoRomaji(input, config, map).map((romajiToken)=>{
        const [start, end, romaji] = romajiToken;
        const makeUpperCase = config.upcaseKatakana && $ce9158473db88422$export$9565d2ed9558b472(input.slice(start, end));
        return makeUpperCase ? romaji.toUpperCase() : romaji;
    }).join('');
}
function $ce9158473db88422$var$splitIntoRomaji(input, options, map) {
    if (!map) map = $ce9158473db88422$var$createKanaToRomajiMap(options.romanization, options.customRomajiMapping);
    const config = Object.assign({}, {
        isDestinationRomaji: true
    }, options);
    return $ce9158473db88422$var$applyMapping($ce9158473db88422$var$katakanaToHiragana(input, $ce9158473db88422$export$b0fffd8625644e57, config), map, !options.IMEMode);
}
/**
 * Tests a character. Returns true if the character is considered English punctuation.
 * @param  {String} char character string to test
 * @return {Boolean}
 */ function $ce9158473db88422$var$isCharEnglishPunctuation(char = '') {
    if ($ce9158473db88422$var$isEmpty(char)) return false;
    return $ce9158473db88422$var$EN_PUNCTUATION_RANGES.some(([start, end])=>$ce9158473db88422$var$isCharInRange(char, start, end));
}
/**
 * Convert input to [Hiragana](https://en.wikipedia.org/wiki/Hiragana)
 * @param  {String} [input=''] text
 * @param  {DefaultOptions} [options=defaultOptions]
 * @return {String} converted text
 * @example
 * toHiragana('toukyou, オオサカ')
 * // => 'とうきょう、　おおさか'
 * toHiragana('only カナ', { passRomaji: true })
 * // => 'only かな'
 * toHiragana('wi')
 * // => 'うぃ'
 * toHiragana('wi', { useObsoleteKana: true })
 * // => 'ゐ'
 */ function $ce9158473db88422$export$28ab6cab47a15260(input = '', options = {}) {
    const config = $ce9158473db88422$var$mergeWithDefaultOptions(options);
    if (config.passRomaji) return $ce9158473db88422$var$katakanaToHiragana(input, $ce9158473db88422$export$b0fffd8625644e57, config);
    if ($ce9158473db88422$export$e534968524b67a52(input, {
        passKanji: true
    })) {
        const convertedKatakana = $ce9158473db88422$var$katakanaToHiragana(input, $ce9158473db88422$export$b0fffd8625644e57, config);
        return $ce9158473db88422$export$4973add5c59f0c7b(convertedKatakana.toLowerCase(), config);
    }
    if ($ce9158473db88422$export$28956e30362f46cb(input) || $ce9158473db88422$var$isCharEnglishPunctuation(input)) return $ce9158473db88422$export$4973add5c59f0c7b(input.toLowerCase(), config);
    return $ce9158473db88422$var$katakanaToHiragana(input, $ce9158473db88422$export$b0fffd8625644e57, config);
}
/**
 * Convert input to [Katakana](https://en.wikipedia.org/wiki/Katakana)
 * @param  {String} [input=''] text
 * @param  {DefaultOptions} [options=defaultOptions]
 * @return {String} converted text
 * @example
 * toKatakana('toukyou, おおさか')
 * // => 'トウキョウ、　オオサカ'
 * toKatakana('only かな', { passRomaji: true })
 * // => 'only カナ'
 * toKatakana('wi')
 * // => 'ウィ'
 * toKatakana('wi', { useObsoleteKana: true })
 * // => 'ヰ'
 */ function $ce9158473db88422$export$a7c1b085022f6eaa(input = '', options = {}) {
    const mergedOptions = $ce9158473db88422$var$mergeWithDefaultOptions(options);
    if (mergedOptions.passRomaji) return $ce9158473db88422$var$hiraganaToKatakana(input);
    if ($ce9158473db88422$export$e534968524b67a52(input) || $ce9158473db88422$export$28956e30362f46cb(input) || $ce9158473db88422$var$isCharEnglishPunctuation(input)) {
        const hiragana = $ce9158473db88422$export$4973add5c59f0c7b(input.toLowerCase(), mergedOptions);
        return $ce9158473db88422$var$hiraganaToKatakana(hiragana);
    }
    return $ce9158473db88422$var$hiraganaToKatakana(input);
}
/**
 * Tests a character. Returns true if the character is considered Japanese punctuation.
 * @param  {String} char character string to test
 * @return {Boolean}
 */ function $ce9158473db88422$var$isCharJapanesePunctuation(char = '') {
    if ($ce9158473db88422$var$isEmpty(char) || $ce9158473db88422$var$isCharIterationMark(char)) return false;
    return $ce9158473db88422$var$JA_PUNCTUATION_RANGES.some(([start, end])=>$ce9158473db88422$var$isCharInRange(char, start, end));
}
const $ce9158473db88422$var$isCharEnSpace = (x)=>x === ' ';
const $ce9158473db88422$var$isCharJaSpace = (x)=>x === "\u3000";
const $ce9158473db88422$var$isCharJaNum = (x)=>/[０-９]/.test(x);
const $ce9158473db88422$var$isCharEnNum = (x)=>/[0-9]/.test(x);
const $ce9158473db88422$var$TOKEN_TYPES = {
    EN: 'en',
    JA: 'ja',
    EN_NUM: 'englishNumeral',
    JA_NUM: 'japaneseNumeral',
    EN_PUNC: 'englishPunctuation',
    JA_PUNC: 'japanesePunctuation',
    KANJI: 'kanji',
    HIRAGANA: 'hiragana',
    KATAKANA: 'katakana',
    SPACE: 'space',
    OTHER: 'other'
};
// prettier-ignore
function $ce9158473db88422$var$getType(input, compact = false) {
    const { EN: EN, JA: JA, EN_NUM: EN_NUM, JA_NUM: JA_NUM, EN_PUNC: EN_PUNC, JA_PUNC: JA_PUNC, KANJI: KANJI, HIRAGANA: HIRAGANA, KATAKANA: KATAKANA, SPACE: SPACE, OTHER: OTHER } = $ce9158473db88422$var$TOKEN_TYPES;
    if (compact) switch(true){
        case $ce9158473db88422$var$isCharJaNum(input):
            return OTHER;
        case $ce9158473db88422$var$isCharEnNum(input):
            return OTHER;
        case $ce9158473db88422$var$isCharEnSpace(input):
            return EN;
        case $ce9158473db88422$var$isCharEnglishPunctuation(input):
            return OTHER;
        case $ce9158473db88422$var$isCharJaSpace(input):
            return JA;
        case $ce9158473db88422$var$isCharJapanesePunctuation(input):
            return OTHER;
        case $ce9158473db88422$var$isCharJapanese(input):
            return JA;
        case $ce9158473db88422$var$isCharRomaji(input):
            return EN;
        default:
            return OTHER;
    }
    else switch(true){
        case $ce9158473db88422$var$isCharJaSpace(input):
            return SPACE;
        case $ce9158473db88422$var$isCharEnSpace(input):
            return SPACE;
        case $ce9158473db88422$var$isCharJaNum(input):
            return JA_NUM;
        case $ce9158473db88422$var$isCharEnNum(input):
            return EN_NUM;
        case $ce9158473db88422$var$isCharEnglishPunctuation(input):
            return EN_PUNC;
        case $ce9158473db88422$var$isCharJapanesePunctuation(input):
            return JA_PUNC;
        case $ce9158473db88422$var$isCharKanji(input):
            return KANJI;
        case $ce9158473db88422$var$isCharHiragana(input):
            return HIRAGANA;
        case $ce9158473db88422$var$isCharKatakana(input):
            return KATAKANA;
        case $ce9158473db88422$var$isCharJapanese(input):
            return JA;
        case $ce9158473db88422$var$isCharRomaji(input):
            return EN;
        default:
            return OTHER;
    }
}
/**
 * Splits input into array of strings separated by opinionated token types
 * `'en', 'ja', 'englishNumeral', 'japaneseNumeral','englishPunctuation', 'japanesePunctuation','kanji', 'hiragana', 'katakana', 'space', 'other'`.
 * If `{ compact: true }` then many same-language tokens are combined (spaces + text, kanji + kana, numeral + punctuation).
 * If `{ detailed: true }` then return array will contain `{ type, value }` instead of `'value'`
 * @param  {String} input text
 * @param  {{compact: Boolean | undefined, detailed: Boolean | undefined}} [options={ compact: false, detailed: false}] options to modify output style
 * @return {(String[]|Array.<{type: String, value: String}>)} text split into tokens containing values, or detailed object
 * @example
 * tokenize('ふふフフ')
 * // ['ふふ', 'フフ']
 *
 * tokenize('感じ')
 * // ['感', 'じ']
 *
 * tokenize('人々')
 * // ['人々']
 *
 * tokenize('truly 私は悲しい')
 * // ['truly', ' ', '私', 'は', '悲', 'しい']
 *
 * tokenize('truly 私は悲しい', { compact: true })
 * // ['truly ', '私は悲しい']
 *
 * tokenize('5romaji here...!?人々漢字ひらがなカタ　カナ４「ＳＨＩＯ」。！')
 * // [ '5', 'romaji', ' ', 'here', '...!?', '人々漢字', 'ひらがな', 'カタ', '　', 'カナ', '４', '「', 'ＳＨＩＯ', '」。！']
 *
 * tokenize('5romaji here...!?人々漢字ひらがなカタ　カナ４「ＳＨＩＯ」。！', { compact: true })
 * // [ '5', 'romaji here', '...!?', '人々漢字ひらがなカタ　カナ', '４「', 'ＳＨＩＯ', '」。！']
 *
 * tokenize('5romaji here...!?人々漢字ひらがなカタ　カナ４「ＳＨＩＯ」。！ لنذهب', { detailed: true })
 * // [
 *  { type: 'englishNumeral', value: '5' },
 *  { type: 'en', value: 'romaji' },
 *  { type: 'space', value: ' ' },
 *  { type: 'en', value: 'here' },
 *  { type: 'englishPunctuation', value: '...!?' },
 *  { type: 'kanji', value: '人々漢字' },
 *  { type: 'hiragana', value: 'ひらがな' },
 *  { type: 'katakana', value: 'カタ' },
 *  { type: 'space', value: '　' },
 *  { type: 'katakana', value: 'カナ' },
 *  { type: 'japaneseNumeral', value: '４' },
 *  { type: 'japanesePunctuation', value: '「' },
 *  { type: 'ja', value: 'ＳＨＩＯ' },
 *  { type: 'japanesePunctuation', value: '」。！' },
 *  { type: 'space', value: ' ' },
 *  { type: 'other', value: 'لنذهب' },
 * ]
 *
 * tokenize('5romaji here...!?人々漢字ひらがなカタ　カナ４「ＳＨＩＯ」。！ لنذهب', { compact: true, detailed: true})
 * // [
 *  { type: 'other', value: '5' },
 *  { type: 'en', value: 'romaji here' },
 *  { type: 'other', value: '...!?' },
 *  { type: 'ja', value: '人々漢字ひらがなカタ　カナ' },
 *  { type: 'other', value: '４「' },
 *  { type: 'ja', value: 'ＳＨＩＯ' },
 *  { type: 'other', value: '」。！' },
 *  { type: 'en', value: ' ' },
 *  { type: 'other', value: 'لنذهب' },
 *]
 */ function $ce9158473db88422$export$660b2ee2d4fb4eff(input, { compact: compact = false, detailed: detailed = false } = {}) {
    if (input == null || $ce9158473db88422$var$isEmpty(input)) return [];
    const chars = [
        ...input
    ];
    let initial = chars.shift();
    let prevType = $ce9158473db88422$var$getType(initial, compact);
    initial = detailed ? {
        type: prevType,
        value: initial
    } : initial;
    const result = chars.reduce((tokens, char)=>{
        const currType = $ce9158473db88422$var$getType(char, compact);
        const sameType = currType === prevType;
        prevType = currType;
        let newValue = char;
        if (sameType) newValue = (detailed ? tokens.pop().value : tokens.pop()) + newValue;
        return detailed ? tokens.concat({
            type: currType,
            value: newValue
        }) : tokens.concat(newValue);
    }, [
        initial
    ]);
    return result;
}
const $ce9158473db88422$var$isLeadingWithoutInitialKana = (input, leading)=>leading && !$ce9158473db88422$export$89c35efdd540c5db(input[0]);
const $ce9158473db88422$var$isTrailingWithoutFinalKana = (input, leading)=>!leading && !$ce9158473db88422$export$89c35efdd540c5db(input[input.length - 1]);
const $ce9158473db88422$var$isInvalidMatcher = (input, matchKanji)=>matchKanji && ![
        ...matchKanji
    ].some($ce9158473db88422$export$92376b026946860f) || !matchKanji && $ce9158473db88422$export$89c35efdd540c5db(input);
/**
 * Strips [Okurigana](https://en.wikipedia.org/wiki/Okurigana)
 * @param  {String} input text
 * @param  {{ leading: Boolean | undefined, matchKanji: string | undefined }} [options={ leading: false, matchKanji: '' }] optional config
 * @return {String} text with okurigana removed
 * @example
 * stripOkurigana('踏み込む')
 * // => '踏み込'
 * stripOkurigana('お祝い')
 * // => 'お祝'
 * stripOkurigana('お腹', { leading: true });
 * // => '腹'
 * stripOkurigana('ふみこむ', { matchKanji: '踏み込む' });
 * // => 'ふみこ'
 * stripOkurigana('おみまい', { matchKanji: 'お祝い', leading: true });
 * // => 'みまい'
 */ function $ce9158473db88422$export$765969e1457dc91a(input = '', { leading: leading = false, matchKanji: matchKanji = '' } = {}) {
    if (!$ce9158473db88422$export$33dfa193fc452c06(input) || $ce9158473db88422$var$isLeadingWithoutInitialKana(input, leading) || $ce9158473db88422$var$isTrailingWithoutFinalKana(input, leading) || $ce9158473db88422$var$isInvalidMatcher(input, matchKanji)) return input;
    const chars = matchKanji || input;
    const okuriganaRegex = new RegExp(leading ? `^${$ce9158473db88422$export$660b2ee2d4fb4eff(chars).shift()}` : `${$ce9158473db88422$export$660b2ee2d4fb4eff(chars).pop()}$`);
    return input.replace(okuriganaRegex, '');
}


var $fc57a6a14993e81d$exports = {};
$fc57a6a14993e81d$exports = JSON.parse('{"1":["\u3044\u3061\u304C\u3064"],"2":["\u306B\u304C\u3064"],"3":["\u3055\u3093\u304C\u3064"],"4":["\u3057\u304C\u3064"],"5":["\u3054\u304C\u3064"],"6":["\u308D\u304F\u304C\u3064"],"7":["\u3057\u3061\u304C\u3064","\u306A\u306A\u304C\u3064"],"8":["\u306F\u3061\u304C\u3064"],"9":["\u304F\u304C\u3064"],"10":["\u3058\u3085\u3046\u304C\u3064"],"11":["\u3058\u3085\u3046\u3044\u3061\u304C\u3064"],"12":["\u3058\u3085\u3046\u306B\u304C\u3064"]}');


var $1ff77aefa5853c14$exports = {};
$1ff77aefa5853c14$exports = JSON.parse('{"1":["\u3064\u3044\u305F\u3061","\u3044\u3063\u3074"],"2":["\u3075\u3064\u304B"],"3":["\u307F\u3063\u304B"],"4":["\u3088\u3063\u304B"],"5":["\u3044\u3064\u304B"],"6":["\u3080\u3044\u304B"],"7":["\u306A\u306E\u304B"],"8":["\u3088\u3046\u304B"],"9":["\u3053\u3053\u306E\u304B"],"10":["\u3068\u304A\u304B"],"11":["\u3058\u3085\u3046\u3044\u3061\u306B\u3061"],"12":["\u3058\u3085\u3046\u306B\u306B\u3061"],"13":["\u3058\u3085\u3046\u3055\u3093\u306B\u3061"],"14":["\u3058\u3085\u3046\u3088\u3063\u304B"],"15":["\u3058\u3085\u3046\u3054\u306B\u3061"],"16":["\u3058\u3085\u3046\u308D\u304F\u306B\u3061"],"17":["\u3058\u3085\u3046\u3057\u3061\u306B\u3061","\u3058\u3085\u3046\u306A\u306A\u306B\u3061"],"18":["\u3058\u3085\u3046\u306F\u3061\u306B\u3061"],"19":["\u3058\u3085\u3046\u304F\u306B\u3061"],"20":["\u306F\u3064\u304B"],"21":["\u306B\u3058\u3085\u3046\u3044\u3061\u306B\u3061"],"22":["\u306B\u3058\u3085\u3046\u306B\u306B\u3061"],"23":["\u306B\u3058\u3085\u3046\u3055\u3093\u306B\u3061"],"24":["\u306B\u3058\u3085\u3046\u3088\u3063\u304B"],"25":["\u306B\u3058\u3085\u3046\u3054\u306B\u3061"],"26":["\u306B\u3058\u3085\u3046\u308D\u304F\u306B\u3061"],"27":["\u306B\u3058\u3085\u3046\u3057\u3061\u306B\u3061","\u306B\u3058\u3085\u3046\u306A\u306A\u306B\u3061"],"28":["\u306B\u3058\u3085\u3046\u306F\u3061\u306B\u3061"],"29":["\u306B\u3058\u3085\u3046\u304F\u306B\u3061"],"30":["\u3055\u3093\u3058\u3085\u3046\u306B\u3061"],"31":["\u3055\u3093\u3058\u3085\u3046\u3044\u3061\u306B\u3061"]}');


function $ffcb874c6bc3f00c$var$randomWithin(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
function $ffcb874c6bc3f00c$var$getLastDayOfMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
}
function $ffcb874c6bc3f00c$var$getRandomDate() {
    const year = new Date().getFullYear();
    const month = $ffcb874c6bc3f00c$var$randomWithin(0, 11);
    const day = $ffcb874c6bc3f00c$var$randomWithin(1, $ffcb874c6bc3f00c$var$getLastDayOfMonth(year, month));
    return {
        month: month + 1,
        day: day
    };
}
function $ffcb874c6bc3f00c$var$getPossibleAnswers(month, day) {
    const monthAnswer = (0, (/*@__PURE__*/$parcel$interopDefault($fc57a6a14993e81d$exports)))[month];
    const dayAnswer = (0, (/*@__PURE__*/$parcel$interopDefault($1ff77aefa5853c14$exports)))[day];
    if (!monthAnswer) throw new Error(`Invalid month: ${month}`);
    if (!dayAnswer) throw new Error(`Invalid day: ${day}`);
    const answers = [];
    monthAnswer.forEach((month)=>{
        dayAnswer.forEach((day)=>{
            answers.push(`${month}${day}`);
        });
    });
    return answers;
}
const $ffcb874c6bc3f00c$var$EMPTY_STATS = {
    currentStreak: 0,
    longestStreak: 0
};
const $ffcb874c6bc3f00c$var$STATS_KEY = "jd-stats";
function $ffcb874c6bc3f00c$var$getStats() {
    try {
        const storedStats = localStorage.getItem($ffcb874c6bc3f00c$var$STATS_KEY);
        if (storedStats) {
            const stats = JSON.parse(storedStats);
            return {
                currentStreak: stats.currentStreak || 0,
                longestStreak: stats.longestStreak || 0
            };
        }
        return $ffcb874c6bc3f00c$var$EMPTY_STATS;
    } catch (error) {
        return $ffcb874c6bc3f00c$var$EMPTY_STATS;
    }
}
function $ffcb874c6bc3f00c$var$setStats(stats) {
    try {
        localStorage.setItem($ffcb874c6bc3f00c$var$STATS_KEY, JSON.stringify(stats));
    } catch (error) {
        console.error("Error saving stats to localStorage", error);
    }
}
class $ffcb874c6bc3f00c$var$DatesApp {
    constructor(){
        this.isResultsScreen = false;
        this.stats = $ffcb874c6bc3f00c$var$EMPTY_STATS;
        this.formElement = document.getElementById("answer-form");
        this.inputElement = document.getElementById("answer-input");
        this.questionElement = document.getElementById("question");
        this.answerElement = document.getElementById("answer");
        this.submitButtonElement = document.getElementById("submit-button");
        this.streakElement = document.getElementById("streak");
        (0, $ce9158473db88422$export$2385a24977818dd0)(this.inputElement);
        this.init();
    }
    createQuestion() {
        this.question = $ffcb874c6bc3f00c$var$getRandomDate();
        this.questionElement.innerText = `${this.question.month}\u{6708}${this.question.day}\u{65E5}`;
        this.answerElement.innerText = "";
        this.isResultsScreen = false;
        this.inputElement.value = "";
        this.inputElement.disabled = false;
        this.inputElement.focus();
        this.submitButtonElement.textContent = "Submit";
    }
    checkAnswer() {
        const input = this.inputElement.value;
        const answers = $ffcb874c6bc3f00c$var$getPossibleAnswers(this.question.month, this.question.day);
        const isCorrect = answers.includes(input);
        this.isResultsScreen = true;
        this.answerElement.innerText = answers.join("\u3001");
        this.inputElement.disabled = true;
        this.submitButtonElement.focus();
        this.submitButtonElement.textContent = "Next";
        if (isCorrect) {
            this.stats.currentStreak++;
            if (this.stats.currentStreak > this.stats.longestStreak) this.stats.longestStreak = this.stats.currentStreak;
            this.answerElement.style.color = "green";
        } else {
            this.stats.currentStreak = 0;
            this.answerElement.style.color = "red";
        }
        this.updateStreak();
        $ffcb874c6bc3f00c$var$setStats(this.stats);
    }
    nextScreen() {
        if (this.isResultsScreen) this.createQuestion();
        else this.checkAnswer();
    }
    updateStreak() {
        this.streakElement.innerText = `Current Streak: ${this.stats.currentStreak} | Longest Streak: ${this.stats.longestStreak}`;
    }
    onSubmit(event) {
        event.preventDefault();
        this.nextScreen();
    }
    onTouchEnd(event) {
        if (this.isResultsScreen) this.nextScreen();
    }
    init() {
        this.stats = $ffcb874c6bc3f00c$var$getStats();
        if (this.stats.longestStreak > 0) this.updateStreak();
        this.createQuestion();
        this.formElement.addEventListener("submit", this.onSubmit.bind(this));
        document.addEventListener("touchend", this.onTouchEnd.bind(this));
    }
}
new $ffcb874c6bc3f00c$var$DatesApp();


//# sourceMappingURL=japanese-dates.e118a64f.js.map
